import { Frame } from 'dragonmouse-shared/interfaces';
import Comments from '../Comments';
import * as S from './styles';

interface FrameInfoProps {
	frame: Frame;
}

const FrameInfo = ({ frame }: FrameInfoProps) => {
	return (
		<S.Container>
			<Comments frame={frame} />
		</S.Container>
	);
};

export default FrameInfo;
